import { useContext } from 'react';
import { Outlet } from 'react-router-dom';

import Logo from '@assets/images/PwC_Logo_new.svg';
import Footer from '@components/Footer/Footer';

import { TokenContext } from '@contexts/TokenProvider';

import styles from './Auth.module.scss';

const AuthLayout = () => {
    const { showLogin } = useContext(TokenContext);
    return (
        <div className={styles['auth-layout']} style={{ display: showLogin ? 'flex' : 'none' }}>
            <div className={styles.interactive}>
                <div className={styles['auth-header']}>
                    <Logo className={styles['logo']} />
                </div>
                <div className={styles['auth-form']}>
                    <Outlet />
                </div>
                <Footer />
            </div>
            <div className={styles.pattern} />
        </div>
    );
};

export default AuthLayout;
